<template>
	<v-card color="contained">
		<v-card-text style="background-color: #151618">
			<img :src="livereaderLogo" style="height: 100px; width: auto; margin-right: 50px" />
		</v-card-text>
	</v-card>
</template>

<script setup lang="ts">
const livereaderLogo = "https://assets.livereader.com/asset/xXCbAJawnlM4BI9h.svg";
</script>
